<template>
 <v-row row wrap>

    <v-col cols="12" sm="6" md="4" offset-md="8" offset-sm="6">
        <search-input  @search="performSearch" v-model="search" />
    </v-col>

    <v-col cols="12">

       <div class="table-fixed-header-wrap">
       <v-data-table
                class="mt-3"
                fixed-header
                height="calc(100vh - 260px)"
                :headers="headers"
                :items="items"
                :single-expand="false"
                :server-items-length="totalItems"
                :loading="loading"
                :page.sync="pageNumber"
                :items-per-page.sync="itemsPerPage"
                :sort-by.sync="orderBy"
                :sort-desc.sync="orderDesc"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                @update:page="fetch"
                @update:items-per-page="fetch"
                @update:sort-by="fetch"
                @update:sort-desc="fetch"
        >

            <template slot="no-data">
               <div class="text-xs-center" v-t="'common.noData'"></div>
            </template>

            <template slot="loading">
               <div   class="text-xs-center" v-t="'common.loading'"></div>
            </template>

            <template v-slot:item.deuda="{ item }">
                <div class="text-center">
                    <template v-if="item.deuda != null && Number(item.deuda) > 0">
                        <span class="error--text font-weight-medium">${{ Number(item.deuda).toFixed(2) }}</span>
                    </template>
                    <v-icon v-else small color="success">mdi-check-circle</v-icon>
                </div>
            </template>

            <template v-slot:item.action="{ item }">
                <show-button  @click="$emit('show', item)" />
                <edit-button  @click="$emit('update', item)" />
            </template>

        </v-data-table>
       </div>
    </v-col>
</v-row>
</template>

<script>
   import ProveedorProvider from "../../../providers/ProveedorProvider";
   import { EditButton, ShowButton, SearchInput} from "@dracul/common-frontend"
    
    export default {
        name: "ProveedorList",
        components: { EditButton, ShowButton, SearchInput},
        
        data() {
            return {
                items: [],
                totalItems: 0,
                loading: false,
                orderBy: ['nombre'],
                orderDesc: [false],
                itemsPerPage: 10,
                pageNumber: 1,
                search: ''
            }
        },
        computed: {   
          headers () {
            return [
                    {text: this.$t('proveedor.labels.nombre'), value: 'nombre'},
                    {text: this.$t('proveedor.labels.cuit'), value: 'cuit'},
                    {text: this.$t('proveedor.labels.email'), value: 'email'},
                    {text: this.$t('proveedor.labels.telefono'), value: 'telefono'},
                    { text: this.$t('proveedor.labels.deuda'), value: 'deuda', sortable: false, align: 'center' },
                    {text: this.$t('common.actions'), value: 'action', sortable: false},
                ]
          },
          getOrderBy(){
              return  (Array.isArray(this.orderBy)) ? this.orderBy[0]: this.orderBy
          },
          getOrderDesc(){
              return  (Array.isArray(this.orderDesc)) ? this.orderDesc[0]: this.orderDesc
          } 
        },
        created() {
            this.fetch()
        },
        methods:{
            performSearch(){
                this.pageNumber = 1
                this.fetch()
            },
            fetch() {
                this.loading = true
                ProveedorProvider.paginateProveedores(
                    this.pageNumber, 
                    this.itemsPerPage,
                    this.search || null,
                    this.getOrderBy || 'nombre', 
                    this.getOrderDesc === true
                ).then(r => {
                    const p = r.data && r.data.proveedorPaginate
                    this.items = (p && p.items) || []
                    this.totalItems = (p && p.totalItems) || 0
                }).catch(err => {
                    console.error(err)
                }).finally(() => this.loading = false)
            }
        }
        
    }
</script>

<style scoped>
.table-fixed-header-wrap {
  min-height: 0;
}
</style>
